import { render, staticRenderFns } from "./import.vue?vue&type=template&id=393627b1&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393627b1')) {
      api.createRecord('393627b1', component.options)
    } else {
      api.reload('393627b1', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=393627b1&", function () {
      api.rerender('393627b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seo/import.vue"
export default component.exports